import React from 'react';

/**
 * Modal for managing products that belong to a deposit (kaucja).
 * Props:
 *   selectedDeposit    - current deposit object
 *   depositProducts    - list of assigned products
 *   productSearch      - current search query string
 *   setProductSearch   - setter for search query
 *   searchResults      - list of search results
 *   searchLoading      - boolean
 *   onAssign(productId) - assign product to deposit
 *   onRemove(productId) - remove product from deposit
 *   onClose()          - close the modal
 */
const ProductsModal = ({
  selectedDeposit,
  depositProducts,
  productSearch, setProductSearch,
  searchResults, searchLoading,
  onAssign, onRemove, onClose
}) => (
  <div style={{
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
    justifyContent: 'center', alignItems: 'center', zIndex: 1000
  }}>
    <div style={{
      backgroundColor: 'var(--card-bg)', borderRadius: '8px',
      width: '90%', maxWidth: '800px', maxHeight: '80vh',
      overflow: 'hidden', display: 'flex', flexDirection: 'column'
    }}>
      {/* Header */}
      <div style={{
        padding: '15px 20px', backgroundColor: 'var(--bg)',
        borderBottom: '1px solid var(--border)',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center'
      }}>
        <h4 style={{ margin: 0 }}>
          Produkty objete kaucja: {selectedDeposit.nazwa} ({parseFloat(selectedDeposit.kwota).toFixed(2)} zl)
        </h4>
        <button onClick={onClose} style={{ background: 'none',  fontSize: '20px', cursor: 'pointer' }}>
          &#x2715;
        </button>
      </div>

      {/* Search */}
      <div style={{ padding: '15px 20px', borderBottom: '1px solid var(--border)' }}>
        <div style={{ position: 'relative' }}>
          <input
            type="text"
            placeholder="Wyszukaj produkt (nazwa, kod, EAN) - min. 2 znaki..."
            value={productSearch}
            onChange={(e) => setProductSearch(e.target.value)}
            autoFocus
            style={{ width: '100%', padding: '10px 12px', border: '1px solid var(--border)', borderRadius: '4px', fontSize: '14px' }}
          />
          {searchLoading && (
            <span style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }}>
              Szukam...
            </span>
          )}
        </div>

        {searchResults.length > 0 && (
          <div style={{ marginTop: '10px', maxHeight: '150px', overflowY: 'auto', border: '1px solid var(--border)', borderRadius: '4px' }}>
            {searchResults.map(product => (
              <div
                key={product.id}
                style={{ padding: '8px 12px', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <div>
                  <div style={{ fontWeight: '500' }}>{product.nazwa || product.name}</div>
                  <div style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
                    {product.kod_produktu || product.barcode} | EAN: {product.ean || '-'}
                  </div>
                </div>
                <button
                  onClick={() => onAssign(product.id)}
                  style={{ padding: '4px 12px', border: '1px solid var(--success)', color: 'var(--success)' , borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}
                >
                  + Dodaj
                </button>
              </div>
            ))}
          </div>
        )}

        {searchResults.length === 0 && productSearch.length >= 2 && !searchLoading && (
          <div style={{ marginTop: '10px', color: 'var(--text-muted)', fontSize: '12px' }}>
            Brak wynikow dla "{productSearch}"
          </div>
        )}
      </div>

      {/* Assigned products list */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '15px 20px' }}>
        <h5 style={{ margin: '0 0 10px 0' }}>Przypisane produkty ({depositProducts.length})</h5>
        {depositProducts.length === 0 ? (
          <div style={{ padding: '30px', textAlign: 'center', color: 'var(--text-muted)', backgroundColor: 'var(--bg)', borderRadius: '4px' }}>
            Brak przypisanych produktow. Wyszukaj i dodaj produkty powyzej.
          </div>
        ) : (
          <div style={{ border: '1px solid var(--border)', borderRadius: '4px' }}>
            {depositProducts.map(product => (
              <div
                key={product.produkt_id}
                style={{ padding: '10px 15px', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <div>
                  <div style={{ fontWeight: '500' }}>{product.produkt_nazwa}</div>
                  <div style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
                    {product.kod_produktu} | EAN: {product.ean || '-'} | Cena: {parseFloat(product.cena || 0).toFixed(2)} zl
                  </div>
                </div>
                <button
                  onClick={() => onRemove(product.produkt_id)}
                  style={{ padding: '4px 12px', border: '1px solid var(--danger)', color: 'var(--danger)' , borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}
                >
                  Usun
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Footer */}
      <div style={{ padding: '15px 20px', backgroundColor: 'var(--bg)', borderTop: '1px solid var(--border)', textAlign: 'right' }}>
        <button
          onClick={onClose}
          style={{ padding: '8px 20px', border: '1px solid var(--text-muted)', color: 'var(--text-muted)' , borderRadius: '4px', cursor: 'pointer' }}
        >
          Zamknij
        </button>
      </div>
    </div>
  </div>
);

export default ProductsModal;
